import { Button } from "@mui/material";
import DonationRequestsTable from "./DonationRequestsTable";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { FullPagePaperLayout } from "pages/Layouts/FullPagePaperLayout";
import { PageActions, PageBreadcrumbs, PageSubtitle, PageTitle } from "pages/Layouts/components/PageTitleContainer";

export default function DonationRequests() {
  const navigate = useNavigate();
  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Tech Access" }]} />
      <PageTitle>Donation Requests</PageTitle>
      <PageSubtitle>Add, edit or delete donation requests displayed in our Revivn platform feed.</PageSubtitle>
      <PageActions>
        <Button
          size="small"
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate("/donation-requests/new")}
        >
          ADD NEW REQUEST
        </Button>
      </PageActions>
      <DonationRequestsTable />
    </FullPagePaperLayout>
  );
}
